@let currentLabel = label();
@let currentPlaceholder = placeholder();
@let leftIcon = iconLeft();
@let rightIcon = iconRight();
@let currentHint = hint();

<div class="mb-2">
  <!-- Label -->
  @if (currentLabel) {
    <label
      [for]="effectiveName()"
      class="block mb-1 text-[12px] font-bold"
      [ngClass]="{ 'text-gray-500': isDisabled() }"
    >
      {{ currentLabel }}
    </label>
  }

  <div class="flex items-center gap-2">
    <div class="relative flex-1">
      <!-- Icono izquierdo -->
      @if (leftIcon) {
        <span class="absolute inset-y-0 left-3 flex items-center text-primary pointer-events-none">
          <i [class]="leftIcon"></i>
        </span>
      }

      <!-- Icono derecho -->
      @if (rightIcon) {
        <span class="absolute inset-y-0 right-3 z-10 flex items-center pointer-events-none">
          <i [class]="rightIcon"></i>
        </span>
      }

      <!-- Input -->
      @if (type() !== 'textarea') {
        <input
          [type]="resolvedInputType()"
          [id]="effectiveName()"
          [name]="effectiveName()"
          [(ngModel)]="value"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          (keydown)="onEnterKeyPress($event)"
          (keypress)="onKeyPress($event)"
          (paste)="onPaste($event)"
          (input)="onInputValueChange($event)"
          [disabled]="isDisabled()"
          [placeholder]="currentPlaceholder"
          [attr.maxlength]="type() === 'tel' ? 10 : null"
          class="bg-primary_light block w-full py-2 border-transparent rounded-xl placeholder-gray-400 focus:outline-none text-[16px] transition-colors duration-200"
          [ngClass]="{
            'pl-10': leftIcon,
            'pl-3': !leftIcon,
            'pr-12': rightIcon || type() === 'password',
            'pr-3': !rightIcon && type() !== 'password',
            'border-error': ngControl?.invalid && ngControl?.touched && displayError(),
            'text-error': ngControl?.invalid && ngControl?.touched && displayError(),
            'border-confirm': ngControl && ngControl.valid && ngControl.touched && displayError(),
            'border-gray-300':
              !(ngControl?.invalid && ngControl?.touched) &&
              !(ngControl && ngControl.valid && ngControl.touched),
            'bg-gray-200 cursor-not-allowed text-gray-500': isDisabled(),
          }"
        />
      } @else {
        <textarea
          [id]="effectiveName()"
          [name]="effectiveName()"
          [(ngModel)]="value"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          [disabled]="isDisabled()"
          [placeholder]="currentPlaceholder"
          [attr.rows]="rows()"
          class="bg-primary_light block w-full py-2 border-transparent rounded-xl placeholder-gray-400 focus:outline-none text-[16px] transition-colors duration-200"
          [ngClass]="{
            'pl-10': leftIcon,
            'pl-3': !leftIcon,
            'pr-12': rightIcon,
            'pr-3': !rightIcon,
            'border-error': ngControl?.invalid && ngControl?.touched && displayError(),
            'text-error': ngControl?.invalid && ngControl?.touched && displayError(),
            'border-confirm': ngControl && ngControl.valid && ngControl.touched && displayError(),
            'border-gray-300':
              !(ngControl?.invalid && ngControl?.touched) &&
              !(ngControl && ngControl.valid && ngControl.touched),
            'bg-gray-200 cursor-not-allowed text-gray-500': isDisabled(),
          }"
        ></textarea>
      }

      <!-- Clear Button -->
      @if (clearable() && value && !isDisabled()) {
        <button
          type="button"
          class="absolute inset-y-0 right-3 z-20 flex items-center text-gray-500 hover:text-red-500 bg-transparent opacity-60 hover:opacity-100 transition-opacity"
          (click)="onClear()"
          [title]="'Limpiar'"
        >
          <i class="fas fa-times"></i>
        </button>
      }

      <!-- Toggle password (sigue dentro del input) -->
      @if (type() === 'password') {
        <button
          type="button"
          class="absolute inset-y-0 right-3 z-10 flex items-center text-gray-500 hover:text-primary"
          (click)="togglePasswordVisibility()"
          [disabled]="isDisabled()"
        >
          <i [class]="passwordToggleIcon"></i>
        </button>
      }
    </div>

    @if (displayError()) {
      <div
        *ngIf="ngControl?.invalid && ngControl?.touched && !isDisabled"
        class="flex items-center"
      >
        <i class="fas fa-times-circle text-error text-[20px]"></i>
      </div>
    }
  </div>

  <!-- Hint -->
  @if (currentHint) {
    <p class="mt-1 text-[10px]" [innerHTML]="currentHint"></p>
  }

  <!-- Errores -->
  @if (displayError()) {
    <lib-custom-error-display [errors]="errors()" [control]="ngControl"></lib-custom-error-display>
  }
</div>
